module.exports = __webpack_public_path__ + "static/media/fork.fab11b34.png";